<template lang="pug">

  div

    //-
      -
      - Modal COLOR PICKER
      -
      -

    v-dialog(v-model="visible" max-width="300px" width="100%" persistent)

      .dialogHeader

        .dialogHeaderTitle
          | Escolha uma cor

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="close(false)")

      .dialogBody

        .dialogBodyContent

          //- :modes="['rgba']"
          //- :modes="['hexa']"
          //- show-swatches
          v-color-picker(v-model="color" :modes="['rgba']" :swatches="[['#00cb72', '#2196f3']]" show-swatches)

          .text-right.mt-5
            sos-button(@buttonClick="close(false)" size="medium" buttonLabel="Fechar" buttonIcon="mdi-close" buttonIconSize="16" color="blue").mr-3
            sos-button(@buttonClick="saveColor" size="medium" buttonLabel="Aplicar" buttonIcon="mdi-check" buttonIconSize="16" color="success")

</template>

<script>

  import SosButton from '@/components/SosButton'

  export default {
    name: 'SosColorPicker',

    components: {
      'sos-button': SosButton,
    },

    /* mixins: [
    ], */

    data () {
      return {
        visible: false,

        color: '#FFFFFF',
      }
    },

    beforeDestroy () {
      this.clear()
    },

    methods: {
      reset () {
        this.visible = false
        this.color = '#FFFFFF'
      },

      clear () {
        this.reset()

        delete this.visible
        delete this.color
      },

      open (color) {
        this.visible = true

        this.color = color
      },

      close (confirmed = false) {
        this.reset()
        this.$emit('close', confirmed)
      },

      //
      //
      //

      saveColor () {
        this.close(this.color)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .dialogSubtitle {
    margin: 30px 0 20px 0;
    font-weight: bold;
  }

  .preLocais {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    min-width: 100% !important;
    padding-bottom: 12.5px;
  }

  .locaisMsg {
    color: #777777;
    // font-size: 14px;
    font-weight: 400;
    // color: #495057;
    font-size: 15px;
    // font-weight: 500;
    line-height: 35px;
  }
</style>
